import { NgModule } from '@angular/core';

import { SFormErrorTotalComponent } from './components/form-error-total';
import { FormInputSelectDayOfWeekComponent } from './components/form-input-select-day-of-week';
import { SFormAutoCompleteComponent } from './components/s-form-autocomplete/s-form-autocomplete.component';
import { SFormErrorInputComponent } from './components/s-form-error-input';
import { SFormGroupComponent } from './components/s-form-group/s-form-group.component';
import { SFormInputCheckboxComponent } from './components/s-form-input-checkbox/s-form-input-checkbox.component';
import { SFormInputCodeComponent } from './components/s-form-input-code/s-form-input-code.component';
import { SFormInputDateRangeComponent } from './components/s-form-input-date-range/s-form-input-date-range.component';
import { SFormInputDateTimeComponent } from './components/s-form-input-date-time/form-input-date-time.component';
import { SFormInputDateComponent } from './components/s-form-input-date/s-form-input-date.component';
import { SFormInputDayOfWeekComponent } from './components/s-form-input-day-of-week';
import { SFormInputDurationComponent } from './components/s-form-input-duration';
import { SFormInputEnumComponent } from './components/s-form-input-enum';
import { SFormInputHiddenComponent } from './components/s-form-input-hidden/s-form-input-hidden.component';
import { SFormInputMonthRangeComponent } from './components/s-form-input-month-range/s-form-input-month-range.component';
import { SFormInputMonthComponent } from './components/s-form-input-month/s-form-input-month.component';
import { SFormInputMonthOfYearComponent } from './components/s-form-input-month-of-year/s-form-input-month-of-year.component';
import { SFormInputMultiSelectComponent } from './components/s-form-input-multi-select/s-form-input-multi-select.component';
import { SFormInputNumberComponent } from './components/s-form-input-number/s-form-input-number.component';
import { SFormInputPasswordComponent } from './components/s-form-input-password/s-form-input-password.component';
import { SFormInputSelectComponent } from './components/s-form-input-select';
import { SFormInputTextComponent } from './components/s-form-input-text/s-form-input-text.component';
import { SFormInputWeekRangeComponent } from './components/s-form-input-week-range/s-form-input-week-range.component';
import { SFormInputWeekComponent } from './components/s-form-input-week/s-form-input-week.component';
import { SFormInputComponent } from './components/s-form-input/s-form-input.component';
import { SFormPageComponent } from './components/s-form-page/s-form-page.component';
import { SFormRowComponent } from './components/s-form-row/s-form-row.component';
import { SFormTitleBarComponent } from './components/s-form-title-bar/s-form-title-bar.component';
import { SFormWizardComponent } from './components/s-form-wizard/s-form-wizard.component';
import { SFormError } from './directives';
import { SFormWizardStepDirective } from './directives/s-form-wizard-step.directive';
import { SummitFormDirective } from './directives/summit-form.directive';

//import { FormInputDateTimeComponent } from './components/form-input-date-time/form-input-date-time.component';

@NgModule({
  imports: [
    SFormAutoCompleteComponent,
    SFormError,
    SFormErrorTotalComponent,
    SFormInputComponent,
    SFormAutoCompleteComponent,
    SFormInputDateTimeComponent,
    SFormInputDurationComponent,
    SFormInputEnumComponent,
    SFormInputHiddenComponent,
    SFormInputNumberComponent,
    SFormInputPasswordComponent,
    SFormInputSelectComponent,
    SFormInputDayOfWeekComponent,
    FormInputSelectDayOfWeekComponent,
    SFormInputTextComponent,
    SFormInputMonthComponent,
    SFormInputMonthRangeComponent,
    SFormInputWeekComponent,
    SFormInputWeekRangeComponent,
    SummitFormDirective,
    SFormInputDateComponent,
    SFormInputDateRangeComponent,
    SFormPageComponent,
    SFormInputCodeComponent,
    SFormRowComponent,
    SFormGroupComponent,
    SFormInputMultiSelectComponent,
    SFormWizardStepDirective,
    SFormWizardComponent,
    SFormTitleBarComponent,
    SFormInputCheckboxComponent,
    SFormErrorInputComponent,
    SFormInputMonthOfYearComponent
  ],
  exports: [
    SFormAutoCompleteComponent,
    SFormError,
    SFormErrorTotalComponent,
    SFormInputComponent,
    SFormInputCheckboxComponent,
    SFormAutoCompleteComponent,
    SFormInputDateTimeComponent,
    SFormInputDurationComponent,
    SFormInputEnumComponent,
    SFormInputHiddenComponent,
    SFormInputNumberComponent,
    SFormInputPasswordComponent,
    SFormInputSelectComponent,
    SFormInputDayOfWeekComponent,
    FormInputSelectDayOfWeekComponent,
    SFormInputTextComponent,
    SFormInputMonthComponent,
    SFormInputMonthRangeComponent,
    SFormInputWeekComponent,
    SFormInputWeekRangeComponent,
    SummitFormDirective,
    SFormInputDateComponent,
    SFormInputDateRangeComponent,
    SFormPageComponent,
    SFormInputCodeComponent,
    SFormRowComponent,
    SFormGroupComponent,
    SFormInputMultiSelectComponent,
    SFormWizardStepDirective,
    SFormWizardComponent,
    SFormTitleBarComponent,
    SFormErrorInputComponent,
    SFormInputMonthOfYearComponent
  ]
})
export class SummitFormModule {}
